import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=0888407c&lang=pug&"
import script from "./receipt.vue?vue&type=script&lang=js&"
export * from "./receipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0888407c')) {
      api.createRecord('0888407c', component.options)
    } else {
      api.reload('0888407c', component.options)
    }
    module.hot.accept("./receipt.vue?vue&type=template&id=0888407c&lang=pug&", function () {
      api.rerender('0888407c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/receipt/receipt.vue"
export default component.exports